module.exports = __webpack_public_path__ + "static/media/67.16c81de6.gif";